module.exports = __webpack_public_path__ + "static/img/S-303-MAPLE.a03ebbd.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/S-303-MAPLE.png
// module id = PGEw
// module chunks = 0